import type { QueryHookOptions, TypedDocumentNode } from '@apollo/client';
import { gql, useQuery } from '@apollo/client';
import type { Query } from '@/types/GraphqlSchema';

type ShoreStatusQueryData = Pick<Query, 'shoreStatus'>;
type ShoreStatusQueryVariables = Record<string, never>;

const SHORE_STATUS_QUERY: TypedDocumentNode<ShoreStatusQueryData, ShoreStatusQueryVariables> = gql`
  query shoreStatus {
    shoreStatus {
      id
      name
    }
  }
`;

type ShoreStatusQueryOptions = QueryHookOptions<ShoreStatusQueryData, ShoreStatusQueryVariables>;

export const useShoreStatus = (options?: ShoreStatusQueryOptions) => {
  const queryOptions: ShoreStatusQueryOptions = {
    errorPolicy: 'all',
    ...(options ?? {}),
  };

  const { data, loading, error, refetch } = useQuery(SHORE_STATUS_QUERY, queryOptions);

  return {
    data,
    loading,
    error,
    refetch,
    shoreStatuses: data?.shoreStatus ?? [],
  };
};
